import { render, staticRenderFns } from "./OfferItemCategory.vue?vue&type=template&id=3e9f6718"
import script from "./OfferItemCategory.vue?vue&type=script&lang=js"
export * from "./OfferItemCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports